<template>
  <div class="create-report">
    <!-- <cc-form
      v-model="formData"
      labelWidth="150px"
      ref="form"
      :config="formConfig"
      :rules="rules"
    ></cc-form> -->
    <el-form
      :model="formData"
      ref="form"
      size="mini"
      label-width="150px"
      :rules="rules"
    >
      <el-form-item prop="productId" label="Job ID">
        <RemoteSelect v-model="formData.productId" />
      </el-form-item>
      <el-form-item prop="feeMonth" :label="$t('statistics.feeMonth')">
        <el-date-picker v-model="formData.feeMonth" type="month">
        </el-date-picker>
      </el-form-item>
      <el-form-item prop="feeType" :label="$t('statistics.feeType')">
        <el-select v-model="formData.feeType">
          <el-option
            :value="0"
            :label="$t('statistics.constants.feeType[0]')"
          ></el-option>
          <el-option
            :value="1"
            :label="$t('statistics.constants.feeType[1]')"
          ></el-option>
          <el-option
            :value="2"
            :label="$t('statistics.constants.feeType[2]')"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="laborCost" :label="$t('statistics.laborCost')">
        <el-input v-model="formData.laborCost"></el-input>
      </el-form-item>
      <el-form-item prop="travelCost" :label="$t('statistics.travelCost')">
        <el-input v-model="formData.travelCost"></el-input>
      </el-form-item>
      <el-form-item prop="partsCost" :label="$t('statistics.partsCost')">
        <el-input v-model="formData.partsCost"></el-input>
      </el-form-item>
      <el-form-item prop="otherCost" :label="$t('statistics.otherCost')">
        <el-input v-model="formData.otherCost"></el-input>
      </el-form-item>
      <el-form-item prop="remark" :label="$t('statistics.remark')">
        <el-input
          v-model="formData.remark"
          type="textarea"
          :rows="4"
        ></el-input>
      </el-form-item>
    </el-form>

    <div class="action" style="margin-left: 120px; margin-top: 20px">
      <el-button size="mini" @click="$emit('cancel')">
        {{ $t("statistics.cancel") }}
      </el-button>
      <el-button size="mini" type="primary" @click="onSubmit">
        {{ $t("statistics.submit") }}
      </el-button>
    </div>
  </div>
</template>

<script>
import RemoteSelect from "./RemoteSelect.vue";
// 财务费用提报

const defaultFormData = {
  productId: "",
  feeMonth: "",
  feeType: "",
  laborCost: "",
  travelCost: "",
  partsCost: "",
  otherCost: "",
  remark: "",
};

export default {
  name: "CreateReport",
  components: { RemoteSelect },
  data() {
    const validatorNumber = (rule, value, callback) => {
      if (!value) {
        callback();
        return;
      }
      if (isNaN(Number(value))) {
        callback(new Error(this.$t("statistics.tips.validNumberError")));
      } else {
        callback();
      }
    };
    return {
      formData: {
        ...defaultFormData,
      },
      formConfig: {
        props: [
          {
            type: "component",
            name: "productId",
            label: "Job ID",
            componentName: RemoteSelect,
          },
          {
            type: "month",
            name: "feeMonth",
            label: this.$t("statistics.feeMonth"),
          },
          {
            type: "select",
            name: "feeType",
            label: this.$t("statistics.feeType"),
            options: [
              { label: this.$t("statistics.constants.feeType[0]"), value: 0 },
              { label: this.$t("statistics.constants.feeType[1]"), value: 1 },
              { label: this.$t("statistics.constants.feeType[2]"), value: 2 },
            ],
          },
          {
            type: "input",
            name: "laborCost",
            label: this.$t("statistics.laborCost"),
          },
          {
            type: "input",
            name: "travelCost",
            label: this.$t("statistics.travelCost"),
          },
          {
            type: "input",
            name: "partsCost",
            label: this.$t("statistics.partsCost"),
          },
          {
            type: "input",
            name: "otherCost",
            label: this.$t("statistics.otherCost"),
          },
          {
            type: "textarea",
            name: "remark",
            label: this.$t("statistics.remark"),
          },
        ],
      },
      rules: {
        productId: [
          {
            required: true,
            message: this.$t("statistics.tips.validJobIdError"),
            trigger: "change",
          },
        ],
        feeMonth: [
          {
            required: true,
            message: this.$t("statistics.tips.validFeeMonthError"),
            trigger: "blur",
          },
        ],
        feeType: [
          {
            required: true,
            message: this.$t("statistics.tips.validFeeType"),
            trigger: "change",
          },
        ],
        laborCost: [{ validator: validatorNumber, trigger: "change" }],
        travelCost: [{ validator: validatorNumber, trigger: "change" }],
        partsCost: [{ validator: validatorNumber, trigger: "change" }],
        otherCost: [{ validator: validatorNumber, trigger: "change" }],
      },
    };
  },
  methods: {
    onSubmit() {
      const elFormRef = this.$refs["form"];
      elFormRef.validate((valid) => {
        if (!valid) return false;
        let formData = { ...this.formData };
        if (formData.laborCost) {
          formData.laborCost = formData.laborCost * 100;
        }
        if (formData.travelCost) {
          formData.travelCost = formData.travelCost * 100;
        }
        if (formData.partsCost) {
          formData.partsCost = formData.partsCost * 100;
        }
        if (formData.otherCost) {
          formData.otherCost = formData.otherCost * 100;
        }
        if (formData.salesFee) {
          formData.salesFee = formData.salesFee * 100;
        }
        this.createReport(formData)
          .then(() => {
            this.$emit("done");
          })
          .catch((err) => {
            this.$message.error(err.response.data.message);
          });
      });
    },
    async createReport(payload) {
      return await this.ccRequest.do(
        "admin/fsb/financial/save",
        payload,
        "POSTJSON"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.create-report {
}
</style>
